import { RouteConfig } from 'vue-router'

// import Orders from './views/Orders.vue'
// import OrderList from './components/orders/order-list.vue'

import { Store } from 'vuex'

import State from './store/types'
import SecurityState from './store/security/types'
import { isAuthenticated } from './common/helpers/user-helpers'

export function getRoutes(): RouteConfig[] {
  return [
    // TODO: return /login or something-or-other
  ]
}

export function getWaits(store: Store<State>) {
  return [
    // Note: this is needed for all things, but security just happens to be the first one
    async (to: any, from: any, next: any) => {
      await (store as any).restored
      await (store.state as any).security.restored
      next()
    },
    async (to: any, from: any, next: any) => {
      const securityState = (store.state as any).security as SecurityState
      if (securityState.currentUser.loading) {
        await store.dispatch('security/getCurrentUser', { root: true })
      }
      next()
    },
  ]
}

export function getAuthenticationWaits(store: Store<State>) {
  return [
    async (to: any, from: any, next: any) => {
      // All the routes but authentication will require auth, so using a flag to skip instead of to enforce
      const securityState = (store.state as any).security as SecurityState
      const requiresAuthentication = to.meta.allowNotAuthenticated !== undefined ? !to.meta.allowNotAuthenticated : !(to.matched.some((route: any) => route.meta.allowNotAuthenticated))
      const allowAuthenticated = to.meta.allowAuthenticated !== undefined ? to.meta.allowAuthenticated : (to.matched.some((route: any) => route.meta.allowAuthenticated))
      const isUserAuthenticated = isAuthenticated(securityState.currentUser)

      // If user is authenticated, then the user cant go to non auth routes
      if (!requiresAuthentication && isUserAuthenticated && !allowAuthenticated) {
        next('')
        return
      } else if (!requiresAuthentication ||
        isUserAuthenticated ||
        allowAuthenticated) {
        next()
        return
      }

      next('/authentication/login')
    },
  ]
}
